import { Button, ButtonMode } from '@creditsights/styleguide-web';
import classNames from 'classnames';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '../Modal.module.scss';
import { FieldValues, AssetClass } from '../types';

interface Step1Props {
  onChangeType: (assetClass: AssetClass) => void;
}

const Step1 = ({ onChangeType }: Step1Props): React.ReactElement => {
  const { watch } = useFormContext<FieldValues>();
  const assetClass = watch('assetClass');

  return (
    <>
      <div className={styles.modalHeader}>Select an asset class to begin</div>
      <div className={styles.modalSubHeader}>
        Please submit all documents and necessary information to best process your request.
      </div>
      <div className={styles.modalDocTypes}>
        <div>
          <Button
            className={classNames(
              styles.modalFormButton,
              {
                [styles.modalFormButton_active]: assetClass === 'loan',
              },
              styles.modalDocType
            )}
            mode={ButtonMode.SECONDARY}
            onClick={() => onChangeType('loan')}
          >
            Loan
          </Button>
        </div>
        <div>
          <Button
            className={classNames(
              styles.modalFormButton,
              {
                [styles.modalFormButton_active]: assetClass === 'bond',
              },
              styles.modalDocType
            )}
            mode={ButtonMode.SECONDARY}
            onClick={() => onChangeType('bond')}
          >
            Bond
          </Button>
        </div>
      </div>
      <div>
        Not sure?{' '}
        <span className={styles.modalLink} onClick={() => onChangeType('other')}>
          Click here for other
        </span>
      </div>
    </>
  );
};

export default Step1;
